import { Component, inject, Input } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { Verification } from "@bitwarden/common/types/verification";
import { BasiqUserAction } from "@bitwarden/web-vault/app/services/syncing/basiq/actions/basiq.action.user";
import { UserStoreService } from "@bitwarden/web-vault/app/services/store/user/user.store.service";
import { TransactionStoreService } from "@bitwarden/web-vault/app/services/store/transaction/transaction.store.service";

@Component({
  selector: "app-remove-basiq-consent",
  templateUrl: "./remove-basiq-consent.component.html",
})
export class RemoveBasiqConsentComponent {
  private basiqUserAction: BasiqUserAction;
  private userStore: UserStoreService;
  private transactionStore: TransactionStoreService;
  @Input() organizationId?: string = null;

  masterPassword: Verification;
  keepDataIn = true;
  deleting = false;

  constructor(
    private i18nService: I18nService,
    private platformUtilsService: PlatformUtilsService,
    private logService: LogService,
    private dialogRef: MatDialogRef<RemoveBasiqConsentComponent>,
  ) {
    this.basiqUserAction = inject(BasiqUserAction);
    this.userStore = inject(UserStoreService);
    this.transactionStore = inject(TransactionStoreService);
  }

  async submit() {
    try {
      this.deleting = true;
      const isRemoved = await this.basiqUserAction.removeConsent(
        this.keepDataIn,
        this.masterPassword,
      );

      if (!isRemoved) {
        return;
      }

      if (!this.keepDataIn) {
        const basiqAccounts = this.userStore.getBasiqAccounts();
        const isDataDeleted = await this.transactionStore.purgeMultipleAccounts(basiqAccounts);

        if (!isDataDeleted) {
          this.platformUtilsService.showToast(
            "error",
            "Error Occurred",
            this.i18nService.t("consentRemovedButDataNot"),
          );
          this.logService.error("Consent removed but data con not");
        }
      }

      this.deleting = false;

      this.dialogRef.close();
      this.platformUtilsService.showToast(
        "success",
        null,
        this.i18nService.t("basiqConsentRemovedSuccessfully"),
      );
    } catch (e) {
      this.platformUtilsService.showToast(
        "error",
        "Error Occurred",
        this.i18nService.t("somethingWentWrong"),
      );
      this.logService.error(e);
    } finally {
      this.deleting = false;
    }
  }

  setKeepDataIn(value: boolean) {
    this.keepDataIn = value;
  }

  closeForm() {
    this.dialogRef.close();
  }
}
